import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

import { FSWalletQrisRepository } from '../../../core/repository/fs-wallet-qris.repository';
import { OtpRequestDTO } from '../../../core/usecase/fs-wallet-qris/interface/otp-request.dto';
import { QrisDecodeDTO } from '../../../core/usecase/fs-wallet-qris/interface/qris-decode.dto';
import { QrisPaymentDTO } from '../../../core/usecase/fs-wallet-qris/interface/qris-payment.dto';
import { QrisTrxStatusDTO } from '../../../core/usecase/fs-wallet-qris/interface/qris-trx-status.dto';
import { ValidatePinDTO } from '../../../core/usecase/fs-wallet-qris/interface/validate-pin.dto';
import {
  HttpWalletQrisDecodeCollectionResponse,
  HttpWalletQrisPaymentCollectionResponse,
  HttpWalletQrisRequestPinCollectionResponse,
  HttpWalletQrisTrxStatusCollectionResponse,
  HttpWalletQrisValidatePinCollectionResponse,
} from './http-fs-wallet-qris.collection';

@Injectable({ providedIn: 'root' })
export class HttpFSWalletQrisRepository implements FSWalletQrisRepository {
  private readonly fs_wallet_account_int_api_url: string =
    environment.paper_mars_api_url + '/internal/wallets';

  constructor(private readonly http: HttpClient) {}


  QrisDecode(
    data: QrisDecodeDTO
  ): Observable<HttpWalletQrisDecodeCollectionResponse> {
    const load_url = this.fs_wallet_account_int_api_url + '/' + data.wallet_id + '/decode-qr'

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + data.token,
      'company_id': data.company_id,
      'user_id': data.user_id,
    });
    const payload = {
      "encrypted_data": data.encrypted_data,
      "encrypted_key": data.encrypted_key,
    }

    return this.http.post<any>(load_url, payload, { headers: headers });
  }

  QrisPayment(
    data: QrisPaymentDTO
  ): Observable<HttpWalletQrisPaymentCollectionResponse> {
    const load_url = this.fs_wallet_account_int_api_url + '/' + data.wallet_id + '/payment'

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + data.token,
      'company_id': data.company_id,
      'user_id': data.user_id,
      'X-AuthKey':data.auth_key
    });
    const payload = {
      "encrypted_data": data.encrypted_data,
      "encrypted_key": data.encrypted_key,
    }

    return this.http.post<any>(load_url, payload, { headers: headers });
  }

  GetTrxStatus(
    data: QrisTrxStatusDTO
  ): Observable<HttpWalletQrisTrxStatusCollectionResponse> {
    const load_url = this.fs_wallet_account_int_api_url + '/' + data.wallet_id + '/transactions/' + data.transaction_id + '/status'

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + data.token,
      'company_id': data.company_id,
      'user_id': data.user_id,
    });

    return this.http.get<any>(load_url, { headers: headers });
  }

  RequestPin(
    data: OtpRequestDTO
  ): Observable<HttpWalletQrisRequestPinCollectionResponse> {
    const load_url = this.fs_wallet_account_int_api_url + '/' + data.wallet_id + '/pin-transactions/request-pin'

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + data.token,
      'company_id': data.company_id,
      'user_id': data.user_id,
    });

    return this.http.post<any>(load_url, {}, { headers: headers });
  }

  ValidatePin(
    data: ValidatePinDTO
  ): Observable<HttpWalletQrisValidatePinCollectionResponse> {
    const load_url = this.fs_wallet_account_int_api_url + '/' + data.wallet_id + '/pin-transactions/validate-pin'

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + data.token,
      'company_id': data.company_id,
      'user_id': data.user_id,
    });

    const payload = {
      "encrypted_data": data.encrypted_data,
      "encrypted_key": data.encrypted_key,
    }

    return this.http.post<any>(load_url, payload, { headers: headers });
  }
}
